import { Numeric } from "@rothoblaas/design-system";
import { NoticeFormField as FormField } from "../notices/NoticeFormField";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { LC_IMG } from "../../constants";
import useI18n from "../../../../../hooks/useTranslations";
import type { LockCalculatorFormValues } from "../../model/form";

// ─── Props ───

interface LoadsFormProps {
  readOnly?: boolean;
  onOpenHelp?: (text: string, image?: string) => void;
}

// ─── Component ───

export const LoadsForm: FC<LoadsFormProps> = ({ readOnly = false, onOpenHelp }) => {
  const i18n = useI18n();
  const {
    control,
    formState: { errors },
  } = useFormContext<LockCalculatorFormValues>();

  const t = i18n.translation;

  return (
    <>
      {/* verticalLoad — previously fvD */}
      <Controller
        name="loads.vertical"
        control={control}
        render={({ field }) => (
          <FormField name="loads.vertical"
            label={t.lockCalculatorModule?.loads?.fvD}
            error={errors.loads?.vertical}
            isOptional
            showHelp={{
              tooltip: t.lockCalculatorModule?.helpTexts?.fvD,
              onOpen: () =>
                onOpenHelp?.(
                  t.lockCalculatorModule?.helpTexts?.fvD,
                  `${LC_IMG}/design-load.png`,
                ),
            }}
          >
            {({ labelId, isInvalid }) => (
              <Numeric
                {...field}
                value={field.value}
                decimalScale={3}
                suffix={t.common.unitKn}
                id={labelId}
                isInvalid={isInvalid}
                allowNegative={false}
                disabled={readOnly}
                onValueChange={(value) => field.onChange(value)}
              />
            )}
          </FormField>
        )}
      />

      {/* upliftLoad — previously fupD */}
      <Controller
        name="loads.uplift"
        control={control}
        render={({ field }) => (
          <FormField name="loads.uplift"
            label={t.lockCalculatorModule?.loads?.fupD}
            error={errors.loads?.uplift}
            isOptional
            showHelp={{
              tooltip: t.lockCalculatorModule?.helpTexts?.fupD,
              onOpen: () => onOpenHelp?.(t.lockCalculatorModule?.helpTexts?.fupD),
            }}
          >
            {({ labelId, isInvalid }) => (
              <Numeric
                {...field}
                value={field.value}
                decimalScale={3}
                suffix={t.common.unitKn}
                id={labelId}
                isInvalid={isInvalid}
                allowNegative={false}
                disabled={readOnly}
                onValueChange={(value) => field.onChange(value)}
              />
            )}
          </FormField>
        )}
      />

      {/* axialLoad — previously faxD */}
      <Controller
        name="loads.axial"
        control={control}
        render={({ field }) => (
          <FormField name="loads.axial"
            label={t.lockCalculatorModule?.loads?.faxD}
            error={errors.loads?.axial}
            isOptional
            showHelp={{
              tooltip: t.lockCalculatorModule?.helpTexts?.faxD,
              onOpen: () => onOpenHelp?.(t.lockCalculatorModule?.helpTexts?.faxD),
            }}
          >
            {({ labelId, isInvalid }) => (
              <Numeric
                {...field}
                value={field.value}
                decimalScale={3}
                suffix={t.common.unitKn}
                id={labelId}
                isInvalid={isInvalid}
                allowNegative={false}
                disabled={readOnly}
                onValueChange={(value) => field.onChange(value)}
              />
            )}
          </FormField>
        )}
      />

      {/* lateralLoad — previously flatD */}
      <Controller
        name="loads.lateral"
        control={control}
        render={({ field }) => (
          <FormField name="loads.lateral"
            label={t.lockCalculatorModule?.loads?.flatD}
            error={errors.loads?.lateral}
            isOptional
            showHelp={{
              tooltip: t.lockCalculatorModule?.helpTexts?.flatD,
              onOpen: () => onOpenHelp?.(t.lockCalculatorModule?.helpTexts?.flatD),
            }}
          >
            {({ labelId, isInvalid }) => (
              <Numeric
                {...field}
                value={field.value}
                decimalScale={3}
                suffix={t.common.unitKn}
                id={labelId}
                isInvalid={isInvalid}
                allowNegative={false}
                disabled={readOnly}
                onValueChange={(value) => field.onChange(value)}
              />
            )}
          </FormField>
        )}
      />
    </>
  );
};
